import {Component, inject, signal, Signal} from '@angular/core';
import {AlgoliaSearchBoxComponent} from '../../components/algolia-search-box/algolia-search-box.component';
import {CustomerInfoComponent} from '../../components/customer-info/customer-info.component';
import {LoadingIconComponent} from '../../components/loading-icon/loading-icon.component';
import {NeedHelpComponent} from '../../components/need-help/need-help.component';
import {FlexPosService} from '../../core/services/flex-pos.service';
import {CustomerService, SelectedCustomer} from '../../core/services/customer.service';

@Component({
  selector: 'app-customer-page',
  imports: [
    AlgoliaSearchBoxComponent,
    CustomerInfoComponent,
    LoadingIconComponent,
    NeedHelpComponent
  ],
  templateUrl: './customer-page.component.html',
  styleUrl: './customer-page.component.scss'
})
export class CustomerPageComponent {
  private flexPosService = inject(FlexPosService);
  private customerService = inject(CustomerService);


  customer: Signal<SelectedCustomer> = signal({customer: null, loading: false});

  constructor() {
    this.customer = this.customerService.selectedCustomer.asReadonly();
    if (this.customer().customer === null || this.customer().loading) {
      this.flexPosService.initSelectedCustomer();
    }
    this.flexPosService.getEmployee();
  }
}
